export const PERMISSIONS :string[] = [];

export const SALES_MEMBERS_DENIED_PERMISSIONS :string[] = [
  'viewUnitCost',
  'printUnitCost',
  'exportUnitCost',
];

export const ADMIN_DENIED_PERMISSIONS :string[] = [
  'viewUnitCost',
  'printUnitCost',
  'exportUnitCost',
];
